__turbopack_context__.v({
  "align-center": "Text-module-scss-module__3pav4G__align-center",
  "align-left": "Text-module-scss-module__3pav4G__align-left",
  "align-right": "Text-module-scss-module__3pav4G__align-right",
  "color-accent": "Text-module-scss-module__3pav4G__color-accent",
  "color-default": "Text-module-scss-module__3pav4G__color-default",
  "color-error": "Text-module-scss-module__3pav4G__color-error",
  "color-muted": "Text-module-scss-module__3pav4G__color-muted",
  "color-primary": "Text-module-scss-module__3pav4G__color-primary",
  "line-clamp": "Text-module-scss-module__3pav4G__line-clamp",
  "line-height-loose": "Text-module-scss-module__3pav4G__line-height-loose",
  "line-height-normal": "Text-module-scss-module__3pav4G__line-height-normal",
  "line-height-relaxed": "Text-module-scss-module__3pav4G__line-height-relaxed",
  "line-height-snug": "Text-module-scss-module__3pav4G__line-height-snug",
  "line-height-tight": "Text-module-scss-module__3pav4G__line-height-tight",
  "size-base": "Text-module-scss-module__3pav4G__size-base",
  "size-lg": "Text-module-scss-module__3pav4G__size-lg",
  "size-md": "Text-module-scss-module__3pav4G__size-md",
  "size-sm": "Text-module-scss-module__3pav4G__size-sm",
  "size-xl": "Text-module-scss-module__3pav4G__size-xl",
  "size-xs": "Text-module-scss-module__3pav4G__size-xs",
  "text": "Text-module-scss-module__3pav4G__text",
  "truncate": "Text-module-scss-module__3pav4G__truncate",
  "weight-bold": "Text-module-scss-module__3pav4G__weight-bold",
  "weight-medium": "Text-module-scss-module__3pav4G__weight-medium",
  "weight-normal": "Text-module-scss-module__3pav4G__weight-normal",
  "weight-semibold": "Text-module-scss-module__3pav4G__weight-semibold",
  "weight-snug": "Text-module-scss-module__3pav4G__weight-snug",
});
